import { combineReducers } from "redux";
import getAccountDetails from "./getAccountDetails";
import guestRegister from "./guestRegister";
import guestValidateMPIN from "./GuestValidateMPIN";
import ClientLoginDataReducers from "./ClientLoginData";
import unblockUser from "./unblockUser";
import ClientForgotUserID from "./ClientForgotUserID";
import ClientGenOTP from "./ClientGenOTP";
import ClientSetPassword from "./ClientSetPassword";
import ClientValPassword from "./ClientValPassword";
import ClientValOTP from "./ClientValOTP";
import GuestEmailVerifyOTP from "./GuestEmailVerifyOTP";
export default combineReducers({
    guestRegister: guestRegister,
    getAccountDetails: getAccountDetails,
    guestValidateMPIN: guestValidateMPIN,
    ClientLoginDataReducers: ClientLoginDataReducers,
    unblockUser: unblockUser,
    ClientForgotUserID: ClientForgotUserID,
    ClientGenOTP: ClientGenOTP,
    ClientSetPassword: ClientSetPassword,
    ClientValPassword: ClientValPassword,
    ClientValOTP: ClientValOTP,
    GuestEmailVerifyOTP: GuestEmailVerifyOTP,
});
